var bindAjaxSpinner = function() {
  // Listen for Rails UJS ajax:before events on remote forms (excluding certain forms)
  var excluded = ['#ebay-form', '#amazon-form', '.ebay-listing-form'];
  document.querySelectorAll("form[data-remote]").forEach(function(form) {
    if (excluded.some(function(sel) { return form.matches(sel); })) return;
    form.addEventListener('ajax:before', toggleSpinner);
  });
  // Hide spinner when any Rails UJS ajax request completes
  document.addEventListener('ajax:complete', function() {
    var blocker = document.getElementById("blocker");
    if (blocker) blocker.style.display = 'none';
  });
}
window.bindAjaxSpinner = bindAjaxSpinner;

function toggleSpinner() {
  var blocker = document.getElementById("blocker");
  if (!blocker) return;
  blocker.style.display = blocker.style.display === 'none' ? '' : 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  bindAjaxSpinner();
});
